import React from 'react'
import styled from 'styled-components'

import {
  SIMULATION_STATUSES_LABELS,
  SIMULATION_STATUSES_VALUES,
} from 'containers/SpearPhishingAgent/constants'

export const SIMULATION_STATUS_STYLES_BY_VALUE = {
  [SIMULATION_STATUSES_VALUES.SENDING]: {
    color: 'var(--psima-sim-status-sending-bg)',
    status: 'var(--psima-sim-status-sending-text)',
    textColor: 'var(--psima-sim-status-sending-text)',
  },
  [SIMULATION_STATUSES_VALUES.ACTIVE]: {
    color: 'var(--psima-sim-status-active-bg)',
    status: 'var(--psima-sim-status-active-text)',
    textColor: 'var(--psima-sim-status-active-text)',
  },
  [SIMULATION_STATUSES_VALUES.COMPLETED]: {
    color: 'var(--psima-sim-status-completed-bg)',
    status: 'var(--psima-sim-status-completed-text)',
    textColor: 'var(--psima-sim-status-completed-text)',
  },
}

/* Soft dot badge, per the DS 3.0 table rule that a status cell is never plain text.
   Capsule is the agreed shape for status (square is for tags). The hue lives in the dot
   and the tint; the label stays on --color-text so it is readable on every tint rather
   than depending on a colour ramp step that has to clear AA on its own. */
const StatusText = styled.span`
  display: inline-flex;
  align-items: center;
  gap: var(--t-spacing-1-5);
  padding: var(--t-spacing-0-5) var(--t-spacing-2);
  border-radius: var(--t-borders-radius-rounded-full);
  background: ${({ $bg }) => $bg};
  color: var(--color-text);
  font-size: var(--t-typography-font-size-sm);
  font-weight: var(--t-typography-font-weight-medium);
  white-space: nowrap;
`

const StatusDot = styled.span`
  flex-shrink: 0;
  width: var(--t-spacing-1-5);
  height: var(--t-spacing-1-5);
  border-radius: var(--t-borders-radius-rounded-full);
  background: ${({ $color }) => $color};
`

export const SimulationStatusBadge = ({ simulation, status = simulation?.status }) => {
  if (!SIMULATION_STATUSES_VALUES[status?.toUpperCase()]) return null

  const styles = SIMULATION_STATUS_STYLES_BY_VALUE[status]

  return (
    <StatusText $bg={styles.color}>
      <StatusDot $color={styles.textColor} />
      {SIMULATION_STATUSES_LABELS[status]}
    </StatusText>
  )
}
